import { useAppSelector } from 'app/hooks';
import { shallowEqual } from 'react-redux';
import { CustomSystemRefreshState } from 'utils/custom-system-refresh';

export default function useCustomSystemRefreshState(): CustomSystemRefreshState {
  return useAppSelector(
    (state) => ({
      activeCustomSystemSavesByConfig:
        state.systems.activeCustomSystemSavesByConfig,
      customSystemsRevisionByConfig:
        state.systems.customSystemsRevisionByConfig,
      settledCustomSystemsRevisionByConfig:
        state.systems.settledCustomSystemsRevisionByConfig
    }),
    shallowEqual
  );
}
